import { Services } from "@ca.vmedia.tv/services";
import type { OnDemandContent, PlayItem } from "@ca.vmedia.tv/domains";
import { ContentType } from "@ca.vmedia.tv/domains";
import type { AxiosError } from 'axios';
import { Logger } from '@/utils';

export const useFetchRelatedContent = async (currentItem: PlayItem | null, ItemsInLine: number, pageNumber?: number ): Promise<OnDemandContent | null> => {
    try {
        if (!currentItem || !currentItem?.id) {
            throw new Error('Current item id is missing');
        }
        const isVOD = (currentItem.contentType === ContentType.VOD || currentItem.contentType === ContentType.SVOD);
        const relatedContent = isVOD
            ? await Services.Instance.vod.getRelatedSVOD(currentItem.id, ItemsInLine, pageNumber ?? 1)
            : await Services.Instance.vod.getRelatedCraveTV(currentItem.id, ItemsInLine, pageNumber ?? 1);
        return relatedContent;
    } catch (error) {
        Logger.captureError(error as AxiosError | Error);
        return null;
    }
};
